var _circle, _path, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFE8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18v-3a1 1 0 011-1h10a1 1 0 011 1v3m-12 0h-3a1 1 0 00-1 1v8a1 1 0 001 1h3m0-10h12m0 0h3a1 1 0 011 1v8a1 1 0 01-1 1h-3m-12 0v-5a1 1 0 011-1h10a1 1 0 011 1v5m-12 0v5a1 1 0 001 1h10a1 1 0 001-1v-5M21 26h6M21 30h6",
    stroke: "#E11C9C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 6,
    fill: "#E11C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28l-2 2m-2 2l2-2m0 0l-2-2m2 2l2 2",
    stroke: "#FFE8F7",
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGRkU4RjciLz4KPHBhdGggZD0iTTE4IDE4VjE1QzE4IDE0LjQ0NzcgMTguNDQ3NyAxNCAxOSAxNEgyOUMyOS41NTIzIDE0IDMwIDE0LjQ0NzcgMzAgMTVWMThNMTggMThIMTVDMTQuNDQ3NyAxOCAxNCAxOC40NDc3IDE0IDE5VjI3QzE0IDI3LjU1MjMgMTQuNDQ3NyAyOCAxNSAyOEgxOE0xOCAxOEgzME0zMCAxOEgzM0MzMy41NTIzIDE4IDM0IDE4LjQ0NzcgMzQgMTlWMjdDMzQgMjcuNTUyMyAzMy41NTIzIDI4IDMzIDI4SDMwTTE4IDI4VjIzQzE4IDIyLjQ0NzcgMTguNDQ3NyAyMiAxOSAyMkgyOUMyOS41NTIzIDIyIDMwIDIyLjQ0NzcgMzAgMjNWMjhNMTggMjhWMzNDMTggMzMuNTUyMyAxOC40NDc3IDM0IDE5IDM0SDI5QzI5LjU1MjMgMzQgMzAgMzMuNTUyOSAzMCAzMy4wMDA2QzMwIDMwLjkyNDEgMzAgMjggMzAgMjgiIHN0cm9rZT0iI0UxMUM5QyIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yMSAyNkgyNyIgc3Ryb2tlPSIjRTExQzlDIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTIxIDMwSDI3IiBzdHJva2U9IiNFMTFDOUMiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSI2IiBmaWxsPSIjRTExQzlDIi8+CjxwYXRoIGQ9Ik0zMiAyOEwzMCAzME0yOCAzMkwzMCAzME0zMCAzMEwyOCAyOE0zMCAzMEwzMiAzMiIgc3Ryb2tlPSIjRkZFOEY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgPrinter as ReactComponent };